import React, { useState } from "react";
import Dropdown from "./dropdown";

const Faq = ({ statusFlow }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="my-5">
      <div className="flex flex-col items-start px-6">
        <div className="text-[#FFFFFF] font-poppins font-light text-[22px] mb-4">
          Frequently Asked Questions
        </div>
        {statusFlow.frequentlyAskedQuestionsEnabled && statusFlow.frequentlyAskedQuestions.map((question, index) => (
          <div
            key={index}
            className={`pr-3 py-3 w-full border-b-[1px] border-b-[#374151] transition-all duration-300 ease-in-out`}
          >
            <Dropdown
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
              title={question.question}
              body={question.answer}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
